import React from "react";

import styles from "./SubmitFilterButton.module.scss";

const SubmitFilterButton = (props) => {
    const { buttonText, clickHandler } = props;

    return (
        <div className={styles.buttoncontainer}>
            <button className={styles.button} onClick={clickHandler}>{buttonText + " >"}</button>
        </div>
    )
}
export default SubmitFilterButton;